import { z } from 'zod';
import { attachmentSchema } from '../attachments/index.js';
export const AGENDA_DOCX_TEMPLATE_TYPES = ['agenda', 'minutes'];
export const agendaDocxTemplateCreateSchema = z.object({
    name: z.string('Name is required').min(1, 'Name is required').max(255),
    isDefault: z.boolean().optional(),
    type: z.enum(AGENDA_DOCX_TEMPLATE_TYPES).optional().default('agenda'),
    attachment: attachmentSchema,
});
export const agendaDocxTemplateUpdateAttachmentSchema = z.object({
    attachment: attachmentSchema,
    note: z.string().trim().max(1000).nullish(),
});
export const agendaDocxTemplateUpdateSchema = z.object({
    name: z.string('Name is required').min(1, 'Name is required').max(255),
    isDefault: z.boolean().optional(),
});
